export const inr = (v) => {
  const n = Number(v || 0);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n);
};
export const inr0 = (v) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(v || 0));
export const num = (v) => new Intl.NumberFormat("en-IN").format(Number(v || 0));

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return d; }
};
export const todayISO = () => new Date().toISOString().slice(0, 10);

export const STATUS_STYLE = {
  paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  issued: "bg-blue-100 text-blue-700 border-blue-200",
  partially_paid: "bg-amber-100 text-amber-700 border-amber-200",
  overdue: "bg-rose-100 text-rose-700 border-rose-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  expired: "bg-rose-100 text-rose-700 border-rose-200",
  terminated: "bg-slate-100 text-slate-500 border-slate-200",
  vacated: "bg-slate-200 text-slate-600 border-slate-300",
  Vacated: "bg-slate-200 text-slate-600 border-slate-300",
  Occupied: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Vacant: "bg-amber-100 text-amber-700 border-amber-200",
  refunded: "bg-slate-100 text-slate-500 border-slate-200",
  held: "bg-indigo-100 text-indigo-700 border-indigo-200",
};
export const statusLabel = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
